// removed by extract-text-webpack-plugin
module.exports = {"error":"_3TxtZ_kZ7Y9kV-kdW43cGK","checkbox":"_1hn1A3iylNnj7I3GU7Y_2I","input":"M0pofkC3FlWemlQhyBo3C","label":"HMhPZk0i4MLuBNOsFOWWS","container":"_2t_3C2pXX9_ifZwUe_zSxW"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Form/Checkbox/styles.scss
// module id = 2130
// module chunks = 1